import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { scrollToComponent } from 'src/utils/commonMethods'

const VehicleTestimonial = ({ testimonial, enquireModalOpen }) => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.container}>
        <div
          className={classes.testimonialContainer}
          onClick={enquireModalOpen}
        >
          <img
            className={classes.testimonialImage}
            src={testimonial.detailsImage}
            alt='testimonial-details'
          />
        </div>
        <div className={classes.additionalDetailsContainer}>
          <span className={classes.clickToKnowText}>Click to know</span>
          <span
            className={classes.additionalText}
            onClick={() => scrollToComponent('coversHeading')}
          >
            {testimonial?.additionalInsightText}
          </span>
        </div>
      </div>
    </>
  )
}

export default VehicleTestimonial

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    width: '100%',
  },
  additionalDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    alignItems: 'center',
    justifyContent: 'center',
    width: '15%',
  },
  clickToKnowText: {
    fontSize: '13px',
    fontWeight: '400',
    color: '#444444',
  },
  additionalText: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#B92250',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  testimonialContainer: {
    position: 'relative',
    width: '100%',
    marginTop: '30px',
    marginBottom: '30px',
    cursor: 'pointer',
  },

  testimonialImage: {
    height: '100%',
    width: '100%',
  },
  testimonialHeadingContainer: {
    background: '#FFFFFF',
    border: '1px solid #CB87A1',
    borderRadius: '26px',
    position: 'absolute',
    padding: '10px',
    height: '40px',
    top: '-20px',
    left: '10%',
    color: '#6D6D6D',
    fontSize: '13px',
  },
  enquireNowContainer: {
    background: '#B92250',
    borderRadius: '26px',
    position: 'absolute',
    padding: '10px',
    height: '40px',
    bottom: '-20px',
    right: '20%',
    color: COLORS.WHITE,
    fontSize: '13px',
  },
  savedContainer: {},
  gridContainer: {
    padding: '20px',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    height: '100%',
    justifyContent: 'center',
  },
  avatarImage: {
    width: '100px',
    height: '100px',
  },
  personName: {
    fontSize: '15px',
    fontWeight: '500',
    color: '#000000',
  },
  personOccupation: {
    fontSize: '12px',
    fontWeight: '400',
    color: '#686868',
  },
  showroomText: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#3F3F3F',
  },
  showroomPrice: {
    fontSize: '29px',
    fontWeight: '500',
    color: '#3F3F3F',
  },
  trovityText: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#B92250',
  },
  trovityPrice: {
    fontSize: '29px',
    fontWeight: '500',
    color: '#B92250',
  },
  vehicleImage: {
    width: '100%',
    height: '100%',
  },
  vehicleDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    height: '100%',
    alignItems: 'center',
  },
  vehicleLogo: {
    width: '100px !important',
    height: '50px',
  },
  vehicleDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  modelName: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#000000',
  },
  modelType: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#929292',
  },
})
